/**
 * Helper function to collect all endings (regular and static) from all interactive scenes in a novel
 * @param {Object} novel - The novel object containing interactive scenes
 * @returns {Array} - Array of ending objects with id and name (includes both regular and static endings)
 */
export const getAllEndingsFromNovel = (novel) => {
  const allEndings = [];
  
  if (novel?.interactive_scenes) {
    novel.interactive_scenes.forEach(scene => {
      // Collect regular endings
      if (scene.endings && Array.isArray(scene.endings)) {
        scene.endings.forEach(ending => {
          if (ending.id && ending.name) {
            allEndings.push({
              id: ending.id,
              name: `${scene.name} - ${ending.name}`
            });
          }
        });
      }
      
      // Collect static endings
      if (scene.static_endings && Array.isArray(scene.static_endings)) {
        scene.static_endings.forEach(staticEnding => {
          if (staticEnding.id && (staticEnding.name || staticEnding.display_name)) {
            // For conditionals, prioritize internal name, fallback to display_name
            const conditionalName = staticEnding.name || staticEnding.display_name;
            allEndings.push({
              id: staticEnding.id,
              name: `${scene.name} - ${conditionalName}`,
              display_name: staticEnding.display_name
            });
          }
        });
      }
    });
  }
  
  return allEndings;
};
